module.exports = "/images/vessel-2.jpg";